/* eslint-disable no-cond-assign */

import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Dropzone from 'react-dropzone';
import { Backdrop, Zoom, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import * as RawImage from '@helpers/rawImage';
import configs from '@configs';
import { endsWithAny } from '@helpers';
import ImageFilter from '@components/ImageFilter';
import './style.scss';

const MAX_NUM_FILES = 1; // 0 for unlimited
const is_inline = configs.preview_mode === 'inline';
const is_popup = configs.preview_mode === 'popup';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

export default ({
  set_images, images,
  id_prefix = 'uploaded_image',
  onMetadata = () => null,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [zoom_image, set_zoom_image] = useState();
  const [is_loading, set_is_loading] = useState();

  const is_image_already_full = MAX_NUM_FILES !== 0 && (MAX_NUM_FILES <= images.length);
  return (
    <>
      {is_loading && <center><CircularProgress /></center>}
      {
        !is_image_already_full && (
          <Dropzone
            // maxFiles={MAX_NUM_FILES}
            onDrop={files => {
              set_is_loading(true);
              const raw_images = files.filter(f => endsWithAny(configs.raw_formats.map(rf => '.' + rf), f.name.toLowerCase()));
              const normal_images = files.filter(f => !endsWithAny(configs.raw_formats.map(rf => '.' + rf), f.name.toLowerCase()));
              for (let i = 0, f; f = raw_images[i]; i++) {
                const isRaw = endsWithAny(configs.raw_formats.map(rf => '.' + rf), f.name);
                if (isRaw) {
                  RawImage.read(f, ri => {
                    set_is_loading(false);
                    set_images([...images, ri.thumbnail]);
                    onMetadata(ri.metadata);
                  });
                }
              }
              if (MAX_NUM_FILES < normal_images.length + normal_images.length) {
                set_images(normal_images.slice(0, MAX_NUM_FILES));
              } else {
                // const tmpImages = [];
                // f.forEach(i => {
                //   if (!i.type.startsWith('image/')) return;
                //   tmpImages.push(i);
                // });
                // set_images([...images, ...tmpImages]);
                // above code to support RAW image
                set_is_loading(false);
                set_images([...images, ...normal_images]);
              }
            }}
          >
            {({ getRootProps, getInputProps }) => (
              <div {...getRootProps()} className="dropzone-input">
                <div>
                  <i className="fas fa-cloud-upload-alt" style={{ fontSize: '3em' }} />
                  <input {...getInputProps()} />
                  <div>{t('components.drag_drop')}</div>
                </div>
              </div>
            )}
          </Dropzone>
        )
      }
      <div className="row p-2">
        {images.map((f, index) => {
          if (is_popup) {
            return (
              <ImageFilter
                file={f}
                onDelete={() => {
                  if (window.confirm(t('common.delete_confirmation'))) {
                    set_images(images.filter((_, idx) => idx !== index));
                  }
                }}
              />);
          }
          if (is_inline) {
            return (
              <div className="thumbnail-image-container w-100 h-100">
                <div
                  className="button"
                  onClick={() => {
                    if (window.confirm(t('common.delete_confirmation'))) {
                      set_images(images.filter((_, idx) => idx !== index));
                    }
                  }}
                >x</div>
                <img id={id_prefix + index} src={f.src || URL.createObjectURL(f)} /* onClick={() => set_zoom_image(f)} */ />
              </div>
            );
          }
        })}
        {is_inline && (
          <Backdrop className={classes.backdrop} open={!!zoom_image} onClick={() => set_zoom_image()}>
            <Zoom in={!!zoom_image}>
              <img className="img-fluid" src={!!zoom_image ? URL.createObjectURL(zoom_image) : ''} />
            </Zoom>
          </Backdrop>
        )}
      </div>
    </>
  );
};
